import script from "./PossibleProductChanges.vue?vue&type=script&setup=true&lang=js"
export * from "./PossibleProductChanges.vue?vue&type=script&setup=true&lang=js"

import "./PossibleProductChanges.vue?vue&type=style&index=0&id=fac9a574&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fac9a574"]])

export default __exports__